import React from "react";
import "./Footer.scss";
import InstagramIcon from "../../icons/InstagramIcon";
import EmailIcon from "../../icons/EmailIcon";
import PhoneIcon from "../../icons/PhoneIcon";

const Footer = () => {
  return (
    <div className="footer-section">
      <div className="footer-links">
        <a
          href="https://www.instagram.com/stories/highlights/18111832942591524/"
          target="_blank"
          className="footer-link"
        >
          <InstagramIcon size={15} /> Stories • Instagram
        </a>

        <a href="mailto:info@speawards.com" className="footer-link">
          <EmailIcon size={16} /> info@speawards.com
        </a>

        <a href="tel:+971502138470" className="footer-link">
          <PhoneIcon size={16} /> +971 50 213 8470
        </a>
      </div>

      <div className="footer-text">
        Terms & Conditions – Privacy Policy – Copyright ©{" "}
        {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default Footer;
